import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUsuarioPermissao({ commit }, usuarioPermissao) {
      try {
        return await api.post('/usuarios/permissoes', usuarioPermissao)
      } catch (error) {
        throw error
      }
    },

    async getUsuariosPermissao({ commit }) {
      try {
        const response = await api.get('/usuarios/permissoes')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async deleteUsuarioPermissao({ commit }, usuarioPermissaoId) {
      try {
        return await api.delete(`/usuarios/permissoes/${usuarioPermissaoId}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
